exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".apps[data-v-07f7319c]{display:-webkit-box;display:-ms-flexbox;display:flex}.apps button[data-v-07f7319c]{margin-left:10px}.apps .el-menu[data-v-07f7319c]{background:transparent}.apps .el-menu--horizontal>.el-menu-item[data-v-07f7319c]{padding:0 12px;height:45px;line-height:45px;color:#333333}\n", ""]);

// exports
